import { reactive } from 'vue'
import useValidate from '@/composables/useValidate'

const errorObj = reactive({})

const {
  isInputEmpty,
  minInputLength,
  isEmailValid
} = useValidate()

const useSignup = (t) => {
  const nameInputsValidate = (inputName, inputValue) => {
    const trimmedValue = inputValue.trim()
    errorObj[inputName] = isInputEmpty(inputName, trimmedValue, t)
  }
  const emailInputValidate = (inputName, inputValue) => {
    errorObj[inputName] = !inputValue
      ? isInputEmpty(inputName, inputValue, t)
      : isEmailValid(inputName, inputValue, t)
  }
  const telInputValidate = (inputName, inputValue) => {
    errorObj[inputName] = !inputValue
      ? isInputEmpty(inputName, inputValue, t)
      : minInputLength(inputName, inputValue, 7, t)
  }
  const companyNameValidate = (inputName, inputValue) => {
    errorObj[inputName] = !inputValue
      ? isInputEmpty(inputName, inputValue)
      : minInputLength(inputName, inputValue, 1)
  }
  const houseNumberValidate = (inputName, inputValue) => {
    const trimmedValue = inputValue.trim()
    errorObj[inputName] = isInputEmpty(inputName, trimmedValue, t)
  }
  const postalNumberValidate = (inputName, inputValue) => {
    const trimmedValue = inputValue.trim()
    errorObj[inputName] = isInputEmpty(inputName, trimmedValue, t)
  }
  const cityNameValidate = (inputName, inputValue) => {
    const trimmedValue = inputValue.trim()
    errorObj[inputName] = isInputEmpty(inputName, trimmedValue, t)
  }

  return {
    nameInputsValidate,
    emailInputValidate,
    telInputValidate,
    companyNameValidate,
    houseNumberValidate,
    postalNumberValidate,
    cityNameValidate,
    errorObj
  }
}

export default useSignup
